// Componente de rango de fechas para Helpdesk (pestaña Cerrados)
// Rangos: Últimos 15 días, Último mes, Q1, Q2, Q3, Q4

import React from 'react';
import * as rdr from 'react-date-range';
import { es } from 'date-fns/locale';
import { isSameDay, subDays, startOfMonth, endOfMonth } from 'date-fns';
import { Button } from 'react-bootstrap';

const today = new Date();
const year = today.getFullYear();

const defineds = {
  last15Start: subDays(today, 14),
  last15End: today,
  lastMonthStart: startOfMonth(subDays(today, 30)),
  lastMonthEnd: endOfMonth(subDays(today, 30)),
  startOfQ1: new Date(year, 0, 1),
  endOfQ1: new Date(year, 2, 31),
  startOfQ2: new Date(year, 3, 1),
  endOfQ2: new Date(year, 5, 30),
  startOfQ3: new Date(year, 6, 1),
  endOfQ3: new Date(year, 8, 30),
  startOfQ4: new Date(year, 9, 1),
  endOfQ4: new Date(year, 11, 31),
};

const customStaticRanges = [
  { label: 'Últimos 15 días', range: () => ({ startDate: defineds.last15Start, endDate: defineds.last15End }), isSelected(range) { return range.startDate && range.endDate && isSameDay(range.startDate, defineds.last15Start) && isSameDay(range.endDate, defineds.last15End); }},
  { label: 'Último mes', range: () => ({ startDate: defineds.lastMonthStart, endDate: defineds.lastMonthEnd }), isSelected(range) { return range.startDate && range.endDate && isSameDay(range.startDate, defineds.lastMonthStart) && isSameDay(range.endDate, defineds.lastMonthEnd); }},
  { label: `Q1 ${year}`, range: () => ({ startDate: defineds.startOfQ1, endDate: defineds.endOfQ1 }), isSelected(range) { return range.startDate && range.endDate && isSameDay(range.startDate, defineds.startOfQ1) && isSameDay(range.endDate, defineds.endOfQ1); }},
  { label: `Q2 ${year}`, range: () => ({ startDate: defineds.startOfQ2, endDate: defineds.endOfQ2 }), isSelected(range) { return range.startDate && range.endDate && isSameDay(range.startDate, defineds.startOfQ2) && isSameDay(range.endDate, defineds.endOfQ2); }},
  { label: `Q3 ${year}`, range: () => ({ startDate: defineds.startOfQ3, endDate: defineds.endOfQ3 }), isSelected(range) { return range.startDate && range.endDate && isSameDay(range.startDate, defineds.startOfQ3) && isSameDay(range.endDate, defineds.endOfQ3); }},
  { label: `Q4 ${year}`, range: () => ({ startDate: defineds.startOfQ4, endDate: defineds.endOfQ4 }), isSelected(range) { return range.startDate && range.endDate && isSameDay(range.startDate, defineds.startOfQ4) && isSameDay(range.endDate, defineds.endOfQ4); }},
];

function HelpdeskDateRange({ range, handleDateChange, setIsDatePickerOpen }) {
  const handleStaticRangeClick = (staticRange) => {
    const newRange = staticRange.range();
    handleDateChange({
      selection: {
        ...range[0],
        ...newRange,
      },
    });
    setIsDatePickerOpen(false);
  };

  return (
    <div style={{ display: 'flex' }}>
      <div
        className="d-flex flex-column p-2 bg-light border-end"
        style={{ width: '200px' }}
      >
        <h6 className="text-muted ms-2 mt-1 mb-2">Rangos rápidos</h6>
        {customStaticRanges.map((staticRange, index) => (
          <Button
            key={index}
            variant={staticRange.isSelected(range[0]) ? 'primary' : 'light'}
            className="text-start mb-1"
            onClick={() => handleStaticRangeClick(staticRange)}
          >
            {staticRange.label}
          </Button>
        ))}
      </div>
      <div>
        <rdr.DateRange
          locale={es}
          months={1}
          direction="horizontal"
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          ranges={range}
          onChange={handleDateChange}
          staticRanges={[]}
          inputRanges={[]}
        />
      </div>
    </div>
  );
}

export default HelpdeskDateRange;
